import React, { createContext, useContext } from 'react';
import useTripInfo from '../hooks/useTripInfo';

// Create context
const TripInfoContext = createContext(null);

/**
 * Provider component for trip info data
 * @param {Object} props - Component props
 * @returns {JSX.Element} Provider component
 */
export const TripInfoProvider = ({ children }) => {
  const tripInfoData = useTripInfo();
  
  return (
    <TripInfoContext.Provider value={tripInfoData}>
      {children}
    </TripInfoContext.Provider>
  );
};

/**
 * Custom hook to use the trip info context
 * @returns {Object} Trip info context value
 */
export const useTripInfoContext = () => {
  const context = useContext(TripInfoContext);
  
  if (!context) {
    throw new Error('useTripInfoContext must be used within a TripInfoProvider');
  }
  
  return context;
};

export default TripInfoContext;
